import { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../lib/supabase'
import { processarResultadosDaSemana, avancarParaProximaSemana, congelarSpreadsPicks } from '../lib/negocio'

export default function Admin() {
  const { membroAtual, ligaAtual, usuario } = useAuth()
  const [semana, setSemana] = useState(null)
  const [temporada, setTemporada] = useState(null)
  const [participantes, setParticipantes] = useState([])
  const [semPick, setSemPick] = useState([])
  const [loading, setLoading] = useState(true)
  const [msg, setMsg] = useState(null)
  const [editando, setEditando] = useState(null) // { tipo, id, valor }
  const [processando, setProcessando] = useState(false)
  const [abaAtiva, setAbaAtiva] = useState('semana')
  const [semanas, setSemanas] = useState([])
  const [salvandoDeadline, setSalvandoDeadline] = useState(null)
  const [todasLigas, setTodasLigas] = useState([])
  const [picksAtuais, setPicksAtuais] = useState({})

  // Deadlines sugeridos 2026 (horário Brasília = UTC-3)
  // Deadline padrão: véspera do 1o jogo da semana, 20h Brasília
  // Calendário NFL 2026 — horários Brasília (UTC-3)
  // deadline    = 5min antes do 1º jogo da semana (normalmente qui 20h Brasília = 23h UTC)
  // revelar     = igual ao deadline (fecha e revela no mesmo instante)
  // processar   = 2h após o último jogo da semana (normalmente seg ~23h45 ET = ter 02h45 BRT = 05h45 UTC)
  //
  // Semana 1: Jogo inaugural quarta 09/09 às 21h20 BRT (NBC, 20:20 ET). Prazo = qua às 21h15 BRT = 00h15 UTC quinta
  // Semana 12: Jogo especial Thanksgiving Eve qua 25/11 (Rams vs Packers, 21h BRT). Prazo = qua 20h55 BRT
  // Semana 15: Tem jogo no sábado 19/12 → deadline sáb às 14h25 BRT (antes do 1º jogo sab 12:30 ET)
  // Semana 16: Tem jogo quinta 24/12 → deadline qui 20h BRT
  // Semana 17: Tem jogo quinta 31/12 → deadline qui 20h BRT
  // Semana 18: Sem TNF. 1º jogo dom 10/01 às 16h BRT (13:00 ET). Deadline dom 15h55 BRT
  // Playoffs: Wild Card Sáb 16/01; Divisional Sáb-Dom 23-24/01; Conference Dom 31/01; SB Dom 14/02
  const DEADLINES_SUGERIDOS = [
    // Sem 1 — abertura qua 09/09 21h20 BRT, TNF qui 10/09 21h35 BRT (Netflix, Austrália)
    // Deadline: qua 09/09 21h15 BRT = 2026-09-10T00:15:00Z | Revelar: igual | Processar: seg 14/09 03h45 UTC (seg 00h45 BRT)
    { numero: 1,  tipo: 'regular',    label: 'Semana 1',
      deadline:  '2026-09-10T00:15:00Z',  // qua 09/09 21h15 BRT — antes do kickoff da abertura
      revelar:   '2026-09-10T00:15:00Z',  // igual ao deadline
      processar: '2026-09-15T03:45:00Z',  // seg 14/09 00h45 BRT — 2h após MNF (~22h45 ET seg)
      nota: 'Abertura qua 09/09! Prazo antes do jogo Seahawks-Patriots (21h20 BRT)'
    },
    // Sem 2 — TNF qui 17/09 21h15 BRT (Bills vs Lions, Amazon)
    { numero: 2,  tipo: 'regular',    label: 'Semana 2',
      deadline:  '2026-09-18T00:15:00Z',  // qui 17/09 20h55 BRT
      revelar:   '2026-09-18T00:15:00Z',  // igual ao deadline
      processar: '2026-09-22T03:45:00Z',  // seg 21/09 00h45 BRT
      nota: 'TNF: Bills vs Lions (Amazon, 21h15 BRT)'
    },
    // Sem 3 — TNF qui 24/09
    { numero: 3,  tipo: 'regular',    label: 'Semana 3',
      deadline:  '2026-09-25T00:15:00Z',
      revelar:   '2026-09-25T00:15:00Z',
      processar: '2026-09-29T03:45:00Z',
      nota: 'TNF qui 24/09 (Amazon, ~21h15 BRT)'
    },
    // Sem 4 — TNF qui 01/10 (Steelers vs Browns, Amazon)
    { numero: 4,  tipo: 'regular',    label: 'Semana 4',
      deadline:  '2026-10-02T00:15:00Z',
      revelar:   '2026-10-02T00:15:00Z',
      processar: '2026-10-06T03:45:00Z',
      nota: 'TNF: Steelers vs Browns (Amazon, ~21h15 BRT)'
    },
    // Sem 5 — TNF qui 08/10 (Buccaneers vs Cowboys, Amazon)
    { numero: 5,  tipo: 'regular',    label: 'Semana 5',
      deadline:  '2026-10-09T00:15:00Z',
      revelar:   '2026-10-09T00:15:00Z',
      processar: '2026-10-13T03:45:00Z',
      nota: 'TNF: Buccaneers vs Cowboys (Amazon, ~21h15 BRT)'
    },
    // Sem 6 — TNF qui 15/10
    { numero: 6,  tipo: 'regular',    label: 'Semana 6',
      deadline:  '2026-10-16T00:15:00Z',
      revelar:   '2026-10-16T00:15:00Z',
      processar: '2026-10-20T03:45:00Z',
      nota: 'TNF qui 15/10 (Amazon, ~21h15 BRT)'
    },
    // Sem 7 — TNF qui 22/10 | Jogo Londres dom 25/10 (Steelers vs Saints, 12h30 BRT)
    { numero: 7,  tipo: 'regular',    label: 'Semana 7',
      deadline:  '2026-10-23T00:15:00Z',
      revelar:   '2026-10-23T00:15:00Z',
      processar: '2026-10-27T03:45:00Z',  // seg 26/10 00h45 BRT
      nota: 'TNF qui 22/10 | Jogo Londres dom 25/10 (Steelers-Saints)'
    },
    // Sem 8 — TNF qui 29/10
    { numero: 8,  tipo: 'regular',    label: 'Semana 8',
      deadline:  '2026-10-30T00:15:00Z',
      revelar:   '2026-10-30T00:15:00Z',
      processar: '2026-11-03T03:45:00Z',
      nota: 'TNF qui 29/10 (Amazon, ~21h15 BRT)'
    },
    // Sem 9 — TNF qui 05/11 | Jogo Madrid dom 08/11 (Bengals vs Falcons, 14h30 BRT)
    { numero: 9,  tipo: 'regular',    label: 'Semana 9',
      deadline:  '2026-11-06T00:15:00Z',
      revelar:   '2026-11-06T00:15:00Z',
      processar: '2026-11-10T03:45:00Z',
      nota: 'TNF qui 05/11 | Jogo Madrid dom 08/11 (Bengals-Falcons)'
    },
    // Sem 10 — TNF qui 12/11 | Jogo Munique dom 15/11 (Patriots vs Lions, 14h30 BRT)
    { numero: 10, tipo: 'regular',    label: 'Semana 10',
      deadline:  '2026-11-13T00:15:00Z',
      revelar:   '2026-11-13T00:15:00Z',
      processar: '2026-11-17T03:45:00Z',
      nota: 'TNF qui 12/11 | Jogo Munique dom 15/11 (Patriots-Lions)'
    },
    // Sem 11 — TNF qui 19/11 | Jogo México dom 22/11 (Vikings vs 49ers, 22h20 BRT)
    { numero: 11, tipo: 'regular',    label: 'Semana 11',
      deadline:  '2026-11-20T00:15:00Z',
      revelar:   '2026-11-20T00:15:00Z',
      processar: '2026-11-24T03:45:00Z',  // seg 23/11 00h45 BRT (após MNF)
      nota: 'TNF qui 19/11 | Jogo México dom 22/11 (Vikings-49ers)'
    },
    // Sem 12 — Thanksgiving Eve: Rams vs Packers qua 25/11 (Netflix, 21h BRT)
    // Thanksgiving qui 26/11 (3 jogos) + Sex 27/11 Black Friday (Steelers vs Broncos, Amazon, 16h BRT)
    // Deadline: qua 25/11 20h55 BRT = antes do 1º jogo da semana
    { numero: 12, tipo: 'regular',    label: 'Semana 12',
      deadline:  '2026-11-26T00:00:00Z',  // qua 25/11 21h00 BRT — Thanksgiving Eve game
      revelar:   '2026-11-26T00:00:00Z',
      processar: '2026-12-01T03:45:00Z',  // seg 30/11 00h45 BRT
      nota: '⚠️ Thanksgiving! Deadline qua 25/11 (antes Rams-Packers Netflix 21h BRT)'
    },
    // Sem 13 — TNF qui 03/12
    { numero: 13, tipo: 'regular',    label: 'Semana 13',
      deadline:  '2026-12-04T00:15:00Z',
      revelar:   '2026-12-04T00:15:00Z',
      processar: '2026-12-08T03:45:00Z',
      nota: 'TNF qui 03/12 (Amazon, ~21h15 BRT)'
    },
    // Sem 14 — TNF qui 10/12
    { numero: 14, tipo: 'regular',    label: 'Semana 14',
      deadline:  '2026-12-11T00:15:00Z',
      revelar:   '2026-12-11T00:15:00Z',
      processar: '2026-12-15T03:45:00Z',
      nota: 'TNF qui 10/12 (Amazon, ~21h15 BRT)'
    },
    // Sem 15 — TNF qui 17/12 + Jogo CBS sáb 19/12 (CBS exclusivo, ~16h BRT)
    // Deadline: antes do TNF qui 17/12
    { numero: 15, tipo: 'regular',    label: 'Semana 15',
      deadline:  '2026-12-18T00:15:00Z',
      revelar:   '2026-12-18T00:15:00Z',
      processar: '2026-12-22T03:45:00Z',  // seg 21/12 00h45 BRT
      nota: 'TNF qui 17/12 + Jogo CBS sáb 19/12'
    },
    // Sem 16 — TNF qui 24/12 (Natal!) + Tripleheader NFL Net sáb 26/12
    { numero: 16, tipo: 'regular',    label: 'Semana 16',
      deadline:  '2026-12-25T00:15:00Z',  // qui 24/12 20h55 BRT — antes do jogo de Natal
      revelar:   '2026-12-25T00:15:00Z',
      processar: '2026-12-29T03:45:00Z',  // seg 28/12 00h45 BRT
      nota: '🎄 Natal! Deadline qui 24/12 (antes do jogo de Christmas Eve)'
    },
    // Sem 17 — TNF qui 31/12 (Réveillon! Ravens vs Bengals, Amazon)
    { numero: 17, tipo: 'regular',    label: 'Semana 17',
      deadline:  '2027-01-01T00:15:00Z',  // qui 31/12 20h55 BRT — antes do jogo de Réveillon
      revelar:   '2027-01-01T00:15:00Z',
      processar: '2027-01-05T03:45:00Z',  // seg 04/01 00h45 BRT
      nota: '🎆 Réveillon! TNF qui 31/12 Ravens vs Bengals (Amazon)'
    },
    // Sem 18 — Sem TNF. 1º jogo sáb 09/01 (dupla NBC/Peacock, 17h30 e 21h BRT)
    // Deadline: sáb 09/01 17h25 BRT = 2027-01-09T20:25:00Z
    { numero: 18, tipo: 'regular',    label: 'Semana 18',
      deadline:  '2027-01-09T20:25:00Z',  // sáb 09/01 17h25 BRT — antes do 1º jogo sáb
      revelar:   '2027-01-09T20:25:00Z',
      processar: '2027-01-11T04:45:00Z',  // dom 10/01 01h45 BRT — 2h após MNF (ESPN sáb ~22h45 ET)
      nota: '⚠️ Sem TNF! Deadline sáb 09/01 17h25 BRT (jogos sáb+dom)'
    },
    // Wild Card — Sáb 16/01 a seg 18/01/2027 (6 jogos)
    // Deadline: sáb 16/01 antes do 1º jogo (~13h BRT = 10:00 ET NFL Net)
    { numero: 19, tipo: 'wildcard',   label: 'Wild Card',
      deadline:  '2027-01-16T15:55:00Z',  // sáb 16/01 12h55 BRT
      revelar:   '2027-01-16T15:55:00Z',
      processar: '2027-01-19T05:45:00Z',  // seg 18/01 02h45 BRT — 2h após último jogo seg
      nota: 'Wild Card: sáb 16/01 – seg 18/01 (6 jogos)'
    },
    // Divisional — Sáb 23/01 e Dom 24/01/2027 (4 jogos)
    { numero: 20, tipo: 'divisional', label: 'Divisional',
      deadline:  '2027-01-23T15:55:00Z',  // sáb 23/01 12h55 BRT
      revelar:   '2027-01-23T15:55:00Z',
      processar: '2027-01-25T03:45:00Z',  // seg 25/01 00h45 BRT — 2h após SNF dom
      nota: 'Divisional: sáb 23/01 e dom 24/01 (4 jogos)'
    },
    // Conference Championships — Dom 31/01/2027 (2 jogos)
    { numero: 21, tipo: 'conference', label: 'Conference',
      deadline:  '2027-01-31T15:55:00Z',  // dom 31/01 12h55 BRT
      revelar:   '2027-01-31T15:55:00Z',
      processar: '2027-02-01T05:45:00Z',  // seg 01/02 02h45 BRT — 2h após 2º jogo
      nota: 'Conference Championships: dom 31/01 (2 jogos)'
    },
    // Super Bowl LXI — Dom 14/02/2027, SoFi Stadium, Los Angeles (ESPN/ABC)
    // Kickoff ~18h30 ET = 21h30 BRT. Deadline: dom 14/02 21h25 BRT
    { numero: 22, tipo: 'superbowl',  label: 'Super Bowl LXI',
      deadline:  '2027-02-15T00:25:00Z',  // dom 14/02 21h25 BRT — antes do kickoff
      revelar:   '2027-02-15T00:25:00Z',
      processar: '2027-02-15T05:45:00Z',  // seg 15/02 02h45 BRT — 2h após o fim
      nota: '🏆 Super Bowl LXI — SoFi Stadium, Los Angeles (ESPN/ABC, ~21h30 BRT)'
    },
  ]

  if (!membroAtual?.is_admin && ligaAtual?.criado_por !== usuario?.id) {
    return <div style={s.erro}>Acesso restrito ao comissário.</div>
  }

  useEffect(() => {
    carregar()
  }, [ligaAtual?.id]) // eslint-disable-line

  async function carregar() {
    setLoading(true)

    const temp = { id: ligaAtual?.id, vidas_padrao: ligaAtual?.vidas_padrao, ...ligaAtual }
    setTemporada(temp)

    // Prioridade: semana com picks abertos; fallback: primeira não processada; depois: última
    const { data: semAberta } = await supabase
      .from('semanas').select('*')
      .eq('liga_id', ligaAtual?.id)
      .eq('picks_abertos', true)
      .order('numero', { ascending: true })
      .limit(1)
      .maybeSingle()
    let sem = semAberta
    if (!sem) {
      const { data: semNaoProc } = await supabase
        .from('semanas').select('*')
        .eq('liga_id', ligaAtual?.id)
        .eq('resultados_processados', false)
        .order('numero', { ascending: true })
        .limit(1)
        .maybeSingle()
      sem = semNaoProc
    }
    setSemana(sem)

    const { data: semsAll } = await supabase
      .from('semanas').select('*')
      .eq('liga_id', ligaAtual?.id)
      .order('numero', { ascending: true })
    setSemanas(semsAll || [])

    // Se todas as semanas estão processadas, usa a última como semana atual
    if (!sem && semsAll && semsAll.length > 0) {
      setSemana(semsAll[semsAll.length - 1])
    }

    // Busca TODOS os membros da liga — aprovados, pendentes e inativos
    // Usa or() para garantir que membros com ativo=null/false e aprovado=false também apareçam
    const { data: parts } = await supabase
      .from('membros_liga')
      .select('id, liga_id, usuario_id, is_admin, vidas_iniciais, vidas_restantes, aprovado, ativo, pagamento_confirmado')
      .eq('liga_id', ligaAtual?.id)
      .order('criado_em')

    // Busca dados dos usuários separadamente
    const userIds = (parts || []).map(p => p.usuario_id)
    let usersData = []
    if (userIds.length > 0) {
      const { data: ud } = await supabase
        .from('usuarios').select('id, nome_completo, primeiro_nome, whatsapp').in('id', userIds)
      usersData = ud || []
    }
    const partsFormatados = (parts || []).map(p => {
      const u = usersData.find(u => u.id === p.usuario_id)
      return {
        ...p,
        nome: u?.nome_completo || u?.primeiro_nome || `(usuário ${p.usuario_id?.slice(0,8)}...)`,
        whatsapp: u?.whatsapp,
      }
    })
    setParticipantes(partsFormatados)

    // Quem não fez pick na semana atual + mapa de picks atuais
    // Busca direto da tabela picks (admin ve picks da sua liga via RLS policy)
    // Não usa ranking_liga pois a view oculta pick_semana_atual antes de picks_revelados=true
    if (sem) {
      const { data: picksAtuaisDados } = await supabase
        .from('picks')
        .select('membro_id, time_escolhido')
        .eq('semana_id', sem.id)
      const comPick = new Set((picksAtuaisDados || []).map(p => String(p.membro_id)))
      const mapa = {}
      ;(picksAtuaisDados || []).forEach(p => { mapa[p.membro_id] = p.time_escolhido })
      setPicksAtuais(mapa)
      // Mesmo filtro do render: aprovado, ativo e com vidas — evita contar membros inativos/pendentes
      const ativos = partsFormatados.filter(p => p.aprovado && p.ativo !== false && p.vidas_restantes > 0)
      setSemPick(ativos.filter(p => !comPick.has(String(p.id))))
    }

    // Carrega todas as ligas do comissário
    const { data: tl } = await supabase
      .from('ligas').select('*').eq('criado_por', usuario?.id).order('criado_em', { ascending: false })
    setTodasLigas(tl || [])

    setLoading(false)
  }

  async function toggleFlag(campo, valor) {
    if (!semana) return
    const { error } = await supabase
      .from('semanas').update({ [campo]: valor }).eq('id', semana.id)
    if (!error) {
      setSemana({ ...semana, [campo]: valor })
      if (campo === 'spreads_congelados' && valor === true) {
        await congelarSpreadsPicks(semana.id)
      }
      showMsg(`${campo} atualizado!`, 'ok')
    }
  }

  async function handleProcessar() {
    if (!semana) return
    setProcessando(true)
    const { sucesso, erro, processados, proximaSemanaAberta, proximoNumero } = await processarResultadosDaSemana(semana.id)
    setProcessando(false)
    if (sucesso) {
      const msgProxima = proximaSemanaAberta
        ? ` · ✅ Semana ${proximoNumero} aberta automaticamente!`
        : semana.numero < 22
          ? ` · ⚠️ Semana ${proximoNumero} ainda não foi criada — crie no Calendário.`
          : ''
      showMsg(`✓ ${processados} participantes processados!${msgProxima}`, 'ok')
      carregar()
    } else {
      showMsg('Erro: ' + erro, 'erro')
    }
  }

  async function handleAvancar() {
    if (!semana || !temporada) return
    if (!window.confirm(`Avançar para semana ${semana.numero + 1}?`)) return
    const { sucesso, erro } = await avancarParaProximaSemana(temporada.id, semana.numero)
    if (sucesso) {
      showMsg(`✓ Semana ${semana.numero + 1} criada!`, 'ok')
      carregar()
    } else {
      showMsg('Erro: ' + erro, 'erro')
    }
  }

  async function exportarPicksExcel() {
    try {
      // Busca todas as semanas da liga
      const { data: todasSemanas } = await supabase
        .from('semanas').select('id, numero, tipo')
        .eq('liga_id', ligaAtual?.id).order('numero')

      // Busca todos os picks
      const semanaIds = (todasSemanas || []).map(s => s.id)
      const { data: todosPicksDB } = semanaIds.length > 0
        ? await supabase.from('picks').select('membro_id, semana_id, time_escolhido, resultado, spread_congelado, vidas_depois').in('semana_id', semanaIds)
        : { data: [] }

      // Mapeia semana_id → numero
      const semNumMap = {}
      ;(todasSemanas || []).forEach(s => { semNumMap[s.id] = s.numero })

      // Monta linhas CSV
      const semNums = (todasSemanas || []).map(s => s.numero)
      const header = ['Nome', ...semNums.map(n => `S${n} - Time`), ...semNums.map(n => `S${n} - Resultado`), ...semNums.map(n => `S${n} - Spread`), 'Vidas Finais']

      const linhas = [...ativos, ...eliminados].map(p => {
        const picksMembro = (todosPicksDB || []).filter(pk => pk.membro_id === p.id)
        const times = semNums.map(n => {
          const sem = (todasSemanas || []).find(s => s.numero === n)
          const pk = sem ? picksMembro.find(pk => pk.semana_id === sem.id) : null
          return pk?.time_escolhido || ''
        })
        const resultados = semNums.map(n => {
          const sem = (todasSemanas || []).find(s => s.numero === n)
          const pk = sem ? picksMembro.find(pk => pk.semana_id === sem.id) : null
          return pk?.resultado || ''
        })
        const spreads = semNums.map(n => {
          const sem = (todasSemanas || []).find(s => s.numero === n)
          const pk = sem ? picksMembro.find(pk => pk.semana_id === sem.id) : null
          return pk?.spread_congelado ?? ''
        })
        return [p.nome, ...times, ...resultados, ...spreads, p.vidas_restantes]
      })

      const csvContent = [header, ...linhas]
        .map(row => row.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))
        .join('\n')

      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      const semAtualNum = semana?.numero || 'all'
      a.href = url
      a.download = `picks_survival_s${semAtualNum}_${new Date().toISOString().slice(0,10)}.csv`
      a.click()
      URL.revokeObjectURL(url)
      showMsg('✓ Arquivo CSV exportado com sucesso!', 'ok')
    } catch (err) {
      showMsg('Erro ao exportar: ' + err.message, 'erro')
    }
  }

  async function aprovarParticipante(id) {
    await supabase.from('membros_liga').update({ aprovado: true }).eq('id', id)
    showMsg('Participante aprovado!', 'ok')
    carregar()
  }

  async function removerParticipante(id, nome) {
    if (!window.confirm(`Remover ${nome} do campeonato?`)) return
    await supabase.from('membros_liga').update({ ativo: false }).eq('id', id)
    showMsg(`${nome} removido.`, 'ok')
    carregar()
  }

  async function togglePagamento(id, statusAtual) {
    const novoStatus = !statusAtual
    await supabase.from('membros_liga').update({ pagamento_confirmado: novoStatus }).eq('id', id)
    showMsg(novoStatus ? '💰 Pagamento confirmado!' : '⏳ Pagamento marcado como pendente.', 'ok')
    carregar()
  }

  async function salvarEdicao() {
    if (!editando) return
    if (editando.tipo === 'vidas') {
      await supabase.from('membros_liga')
        .update({ vidas_restantes: parseInt(editando.valor) })
        .eq('id', editando.id)
      showMsg('Vidas atualizadas!', 'ok')
    } else if (editando.tipo === 'pick') {
      if (!semana) return
      const novoTime = editando.valor.toUpperCase()
      const ehPlayoffs = semana.tipo !== 'regular'

      const { data: pickAtual } = await supabase
        .from('picks').select('time_escolhido')
        .eq('membro_id', editando.id).eq('semana_id', semana.id)
        .maybeSingle()

      await supabase.from('picks').upsert({
        membro_id: editando.id,
        semana_id: semana.id,
        time_escolhido: novoTime,
        confirmado_em: new Date().toISOString(),
      }, { onConflict: 'membro_id,semana_id' })

      if (!ehPlayoffs) {
        const timeAntigo = pickAtual?.time_escolhido
        if (timeAntigo && timeAntigo !== novoTime) {
          await supabase.from('times_usados').delete()
            .eq('membro_id', editando.id).eq('liga_id', ligaAtual.id).eq('time_abbr', timeAntigo)
        }
        await supabase.from('times_usados').upsert({
          membro_id: editando.id,
          liga_id: ligaAtual.id,
          time_abbr: novoTime,
          semana_numero: semana.numero,
        }, { onConflict: 'membro_id,liga_id,time_abbr' })
      }

      showMsg('Pick atualizado!', 'ok')
    }
    setEditando(null)
    carregar()
  }

  function abrirWhatsApp(p) {
    const num = p.whatsapp?.replace(/\D/g, '')
    if (!num) { showMsg('Participante sem WhatsApp cadastrado.', 'erro'); return }
    const semNum = semana?.numero || '?'
    const deadline = semana?.deadline
      ? new Date(semana.deadline).toLocaleString('pt-BR', { weekday: 'long', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' })
      : '?'
    const texto = encodeURIComponent(
      `Oi ${p.nome.split(' ')[0]}! 🏈 Lembrete do NFL Survival 2026 — você ainda não fez seu pick da semana ${semNum}. Deadline: ${deadline}. Acesse o site para confirmar sua escolha: https://nflsurvival.com.br`
    )
    window.open(`https://web.whatsapp.com/send?phone=${num}&text=${texto}`, '_blank')
  }

  async function salvarDeadline(semanaId, novoDeadline) {
    setSalvandoDeadline(semanaId)
    const { error } = await supabase
      .from('semanas')
      .update({ deadline: novoDeadline })
      .eq('id', semanaId)
    setSalvandoDeadline(null)
    if (!error) {
      setSemanas(prev => prev.map(s => s.id === semanaId ? { ...s, deadline: novoDeadline } : s))
      showMsg('Deadline salvo!', 'ok')
    } else {
      showMsg('Erro ao salvar deadline.', 'erro')
    }
  }

  async function criarSemanaComDeadline(sugestao) {
    if (!temporada) return
    const { error } = await supabase.from('semanas').insert({
      liga_id: temporada.id,
      numero: sugestao.numero,
      tipo: sugestao.tipo,
      deadline: sugestao.deadline,
      agendado_revelar: sugestao.revelar,
      agendado_processar: sugestao.processar,
      picks_abertos: false,
      resultados_processados: false,
      picks_revelados: false,
      spreads_congelados: false,
    })
    if (!error) {
      showMsg(`Semana ${sugestao.numero} criada!`, 'ok')
      carregar()
    } else {
      showMsg('Erro: semana já existe ou outro problema.', 'erro')
    }
  }

  function showMsg(texto, tipo) {
    setMsg({ texto, tipo })
    setTimeout(() => setMsg(null), 3500)
  }

  const pendentesAprovacao = participantes.filter(p => !p.aprovado && p.ativo !== false)
  const ativos = participantes.filter(p => p.aprovado && p.ativo !== false && p.vidas_restantes > 0)
  const eliminados = participantes.filter(p => p.aprovado && p.ativo !== false && p.vidas_restantes === 0)

  return (
    <div>
      <div style={{
        ...s.banner,
        background: semana?.picks_abertos ? '#EAF3DE' : '#FCEBEB',
        borderColor: semana?.picks_abertos ? '#3B6D11' : '#E24B4A',
        color: semana?.picks_abertos ? '#3B6D11' : '#A32D2D',
      }}>
        <span style={{ fontWeight: 600 }}>
          {semana?.picks_abertos ? '🟢' : '🔴'} Semana {semana?.numero || '—'}
          {semana?.picks_abertos ? ' · picks ABERTOS' : ' · picks FECHADOS'}
        </span>
        <span style={{ fontWeight: 400, marginLeft: 8 }}>
          · {ativos.length} ativos · {eliminados.length} eliminados
          {semana?.picks_abertos && semPick.length >= 0 && (
            <> · <strong>{ativos.length - semPick.length}/{ativos.length}</strong> picks feitos</>
          )}
        </span>
      </div>

      {msg && <div style={msg.tipo === 'ok' ? s.msgOk : s.msgErro}>{msg.texto}</div>}

      {/* Sub-abas */}
      <div style={s.subNav}>
        {['semana', 'participantes', 'lembretes', 'calendario', 'ligas'].map(aba => (
          <button key={aba} style={{ ...s.subBtn, ...(abaAtiva === aba ? s.subBtnAtivo : {}) }}
            onClick={() => setAbaAtiva(aba)}>
            {aba === 'semana' ? '⚙️ Semana'
              : aba === 'participantes'
                ? <span>👥 Participantes{pendentesAprovacao.length > 0 && <span style={s.badge}>{pendentesAprovacao.length}</span>}</span>
                : aba === 'lembretes' ? '📱 Lembretes'
                : aba === 'calendario' ? '📅 Calendário'
                : '🏆 Ligas'}
          </button>
        ))}
      </div>

      {loading ? <div style={s.loading}>Carregando...</div> : (
        <>
          {/* ── ABA SEMANA ── */}
          {abaAtiva === 'semana' && !semana && (
            <div style={s.card}>
              <div style={{ textAlign: 'center', padding: '1.5rem 0', color: '#888', fontSize: 13 }}>
                <div style={{ fontSize: 32, marginBottom: 8 }}>📅</div>
                <div style={{ fontWeight: 500, marginBottom: 6, color: '#333' }}>Nenhuma semana cadastrada</div>
                <div style={{ marginBottom: 16 }}>Crie as semanas desta liga na aba Calendário.</div>
                <button style={{ ...s.btnCriar, padding: '8px 20px', fontSize: 13 }} onClick={() => setAbaAtiva('calendario')}>
                  Ir para Calendário →
                </button>
              </div>
            </div>
          )}
          {abaAtiva === 'semana' && semana && (
            <div>
              <div style={s.card}>
                <div style={s.cardTitle}>Controles — semana {semana.numero}</div>

                <div style={s.toggleRow}>
                  <div>
                    <div style={s.toggleLabel}>Picks abertos</div>
                    <div style={s.toggleSub}>Fecha automaticamente no deadline</div>
                  </div>
                  <div style={{ ...s.toggle, ...(semana.picks_abertos ? s.toggleOn : s.toggleOff) }}
                    onClick={() => toggleFlag('picks_abertos', !semana.picks_abertos)}>
                    <div style={{ ...s.toggleDot, ...(semana.picks_abertos ? { right: 2 } : { left: 2 }) }}></div>
                  </div>
                </div>

                <div style={s.toggleRow}>
                  <div>
                    <div style={s.toggleLabel}>Revelar escolhas · congelar spreads</div>
                    <div style={s.toggleSub}>Ativa os dois juntos — picks visíveis e spreads não atualizam mais</div>
                  </div>
                  <div style={{ ...s.toggle, ...(semana.picks_revelados ? s.toggleOn : s.toggleOff) }}
                    onClick={() => {
                      toggleFlag('picks_revelados', !semana.picks_revelados)
                      toggleFlag('spreads_congelados', !semana.picks_revelados)
                    }}>
                    <div style={{ ...s.toggleDot, ...(semana.picks_revelados ? { right: 2 } : { left: 2 }) }}></div>
                  </div>
                </div>

                <button style={s.btn} onClick={handleProcessar} disabled={processando}>
                  {processando ? 'Processando...' : '⚡ Processar resultados da semana'}
                </button>
                <button style={{ ...s.btn, ...s.btnDanger }} onClick={handleAvancar}>
                  ➡️ Avançar para semana {semana.numero + 1}
                </button>
              </div>

              {/* Config vidas padrão */}
              <div style={s.card}>
                <div style={s.cardTitle}>Configurações da temporada</div>
                <div style={{ fontSize: 12, color: '#666', marginBottom: 6 }}>Vidas padrão para novos participantes</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <button style={s.btnSmall} onClick={async () => {
                    if (temporada.vidas_padrao <= 1) return
                    const v = temporada.vidas_padrao - 1
                    await supabase.from('ligas').update({ vidas_padrao: v }).eq('id', ligaAtual?.id)
                    setTemporada({ ...temporada, vidas_padrao: v })
                  }}>−</button>
                  <span style={{ fontSize: 16, fontWeight: 500, color: '#D85A30', minWidth: 20, textAlign: 'center' }}>{temporada?.vidas_padrao}</span>
                  <button style={s.btnSmall} onClick={async () => {
                    const v = temporada.vidas_padrao + 1
                    await supabase.from('ligas').update({ vidas_padrao: v }).eq('id', ligaAtual?.id)
                    setTemporada({ ...temporada, vidas_padrao: v })
                  }}>+</button>
                  <span style={{ fontSize: 12, color: '#888' }}>vidas</span>
                </div>
              </div>
            </div>
          )}

          {/* ── ABA PARTICIPANTES ── */}
          {abaAtiva === 'participantes' && (
            <div>
              {/* Pendentes de aprovação */}
              {pendentesAprovacao.length > 0 && (
                <div style={{ ...s.card, border: '1.5px solid #D85A30', background: '#FFFBF9' }}>
                  <div style={s.cardTitle}>⏳ Aguardando aprovação ({pendentesAprovacao.length})</div>
                  <div style={{ fontSize: 11, color: '#888', marginBottom: 10 }}>
                    Novos jogadores que fizeram cadastro e aguardam liberação
                  </div>
                  {pendentesAprovacao.map(p => (
                    <div key={p.id} style={s.partRow}>
                      <div style={s.partInfo}>
                        <div style={{ fontWeight: 500, fontSize: 13 }}>{p.nome}</div>
                        <div style={{ fontSize: 11, color: '#888' }}>
                          {p.whatsapp || 'sem WhatsApp'}
                          {p.pagamento_confirmado && <span style={{ marginLeft: 6, color: '#3B6D11' }}>💰 pago</span>}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button style={s.btnAprov} onClick={() => aprovarParticipante(p.id)}>✓ Aprovar</button>
                        <button style={s.btnRemove} onClick={() => removerParticipante(p.id, p.nome)}>✗ Rejeitar</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Lista de participantes */}
              <div style={s.card}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                  <div style={s.cardTitle}>👥 Participantes ({participantes.length} total — {ativos.length} ativos · {pendentesAprovacao.length} pendentes · {eliminados.length} eliminados)</div>
                  <button style={s.btnExport} onClick={exportarPicksExcel}>
                    📥 Exportar picks (.csv)
                  </button>
                </div>
                {[...ativos, ...eliminados].map(p => {
                  const elim = p.vidas_restantes === 0
                  return (
                    <div key={p.id} style={{ ...s.partRow, ...(elim ? s.partElim : {}) }}>
                      <div style={s.partInfo}>
                        <div style={{ fontWeight: 500, fontSize: 13 }}>
                          {p.nome}
                          {p.usuario_id === usuario?.id && <span style={s.voceTag}>você</span>}
                          {elim && <span style={s.elimTag}>eliminado</span>}
                          <span
                            style={{ marginLeft: 6, fontSize: 11, cursor: 'pointer', color: p.pagamento_confirmado ? '#3B6D11' : '#BA7517' }}
                            title={p.pagamento_confirmado ? 'Clique para marcar como não pago' : 'Clique para marcar como pago'}
                            onClick={() => togglePagamento(p.id, p.pagamento_confirmado)}
                          >
                            {p.pagamento_confirmado ? '💰 pago' : '⏳ pendente'}
                          </span>
                        </div>
                        <div style={{ fontSize: 11, color: p.whatsapp ? '#888' : '#BA7517' }}>
                          {p.whatsapp || '⚠️ sem WhatsApp'}
                        </div>
                      </div>

                      {/* Vidas */}
                      {editando?.id === p.id && editando?.tipo === 'vidas' ? (
                        <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                          <input style={s.inputSmall} type="number" min="0" max="10"
                            value={editando.valor} onChange={e => setEditando({ ...editando, valor: e.target.value })} />
                          <button style={s.btnSave} onClick={salvarEdicao}>✓</button>
                          <button style={s.btnCancel} onClick={() => setEditando(null)}>✗</button>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                          <span style={{ color: '#D85A30', fontSize: 12 }}>
                            {p.vidas_restantes > 0 ? '♥'.repeat(p.vidas_restantes) : '✕'}
                          </span>
                          {picksAtuais[p.id] && (
                            <span style={{ fontSize: 11, color: '#555', background: '#f5f5f5', borderRadius: 4, padding: '1px 5px' }}>
                              {semana?.picks_revelados ? picksAtuais[p.id] : '✓'}
                            </span>
                          )}
                          <button style={s.btnEdit} onClick={() => setEditando({ tipo: 'vidas', id: p.id, valor: p.vidas_restantes })}>✏️</button>
                          <button style={s.btnEdit} onClick={() => setEditando({ tipo: 'pick', id: p.id, valor: semana?.picks_revelados ? (picksAtuais[p.id] || '') : '' })}>🏈</button>
                          {p.usuario_id !== usuario?.id && (
                            <button style={s.btnRemove} onClick={() => removerParticipante(p.id, p.nome)}>✗</button>
                          )}
                        </div>
                      )}

                      {/* Editar pick */}
                      {editando?.id === p.id && editando?.tipo === 'pick' && (
                        <div style={{ display: 'flex', gap: 4, alignItems: 'center', marginTop: 4, width: '100%' }}>
                          <input style={s.inputSmall} type="text" maxLength={4} placeholder="Ex: KC"
                            value={editando.valor} onChange={e => setEditando({ ...editando, valor: e.target.value })} />
                          <button style={s.btnSave} onClick={salvarEdicao}>✓</button>
                          <button style={s.btnCancel} onClick={() => setEditando(null)}>✗</button>
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </div>
          )}

          {/* ── ABA LEMBRETES ── */}
          {abaAtiva === 'lembretes' && (
            <div>
              <div style={s.card}>
                <div style={s.cardTitle}>📱 Lembretes WhatsApp — semana {semana?.numero}</div>
                {semPick.length === 0 ? (
                  <div style={s.vazio}>✓ Todos os participantes ativos já fizeram seu pick!</div>
                ) : (
                  <>
                    <div style={{ fontSize: 12, color: '#666', marginBottom: 12 }}>
                      {semPick.length} participante{semPick.length > 1 ? 's' : ''} sem pick · clique para abrir no WhatsApp Web
                    </div>
                    {semPick.map(p => (
                      <div key={p.id} style={s.lembRow}>
                        <div style={s.partInfo}>
                          <div style={{ fontWeight: 500, fontSize: 13 }}>{p.nome}</div>
                          <div style={{ fontSize: 11, color: '#888' }}>{p.whatsapp || 'sem WhatsApp'}</div>
                        </div>
                        <button
                          style={p.whatsapp ? s.btnWpp : s.btnWppDis}
                          disabled={!p.whatsapp}
                          onClick={() => abrirWhatsApp(p)}>
                          {p.whatsapp ? '💬 Enviar lembrete' : 'sem número'}
                        </button>
                      </div>
                    ))}
                    <div style={{ fontSize: 11, color: '#999', marginTop: 12, padding: '8px 0', borderTop: '0.5px solid #eee' }}>
                      💡 Cada botão abre o WhatsApp Web com a mensagem pré-preenchida. Basta clicar em Enviar.
                    </div>
                  </>
                )}
              </div>

              {/* Preview da mensagem */}
              <div style={s.card}>
                <div style={s.cardTitle}>Mensagem padrão</div>
                <div style={s.preview}>
                  Oi [nome]! 🏈 Lembrete do NFL Survival 2026 — você ainda não fez seu pick da semana {semana?.numero || '?'}. Deadline: [data/hora]. Acesse o site para confirmar sua escolha!
                </div>
              </div>
            </div>
          )}

          {/* ── ABA LIGAS ── */}
          {abaAtiva === 'ligas' && (
            <div>
              {/* Lista de ligas existentes */}
              {todasLigas.length > 0 && (
                <div style={s.card}>
                  <div style={s.cardTitle}>Suas ligas</div>
                  {todasLigas.map(l => (
                    <div key={l.id} style={s.partRow}>
                      <div style={s.partInfo}>
                        <div style={{ fontWeight: 500, fontSize: 13 }}>{l.nome}</div>
                        <div style={{ fontSize: 11, color: '#888' }}>
                          {l.ano} · semana {l.semana_inicio} em diante · {l.vidas_padrao} vidas · R$ {Number(l.valor_buyin || 0).toFixed(0)} buy-in
                          {l.id === ligaAtual?.id && <span style={{ ...s.voceTag, marginLeft: 6 }}>atual</span>}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                        <span style={{ fontSize: 11, color: l.ativa ? '#3B6D11' : '#999' }}>
                          {l.ativa ? '● ativa' : '○ inativa'}
                        </span>
                        <span style={{ fontSize: 11, color: l.inscricoes_abertas ? '#1A5C9A' : '#999' }}>
                          {l.inscricoes_abertas ? '🔓' : '🔒'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Criar nova liga */}
              <div style={s.card}>
                <div style={s.cardTitle}>🏆 Criar nova liga</div>
                <NovaLigaForm usuario={usuario} onCriada={() => { showMsg('Liga criada!', 'ok'); carregar() }} />
              </div>
            </div>
          )}

          {/* ── ABA CALENDÁRIO ── */}
          {abaAtiva === 'calendario' && (
            <div>
              <div style={{ fontSize: 11, color: '#888', marginBottom: 8, padding: '6px 10px', background: '#f5f5f5', borderRadius: 6 }}>
                🕐 Todos os horários em <strong>horário de Brasília (UTC−3)</strong>
              </div>
              {/* Botão preencher todos */}
              {semanas.some(sem => !sem.agendado_revelar || !sem.agendado_processar) && (
                <button style={{ ...s.btnCriar, marginBottom: 8, display: 'block', width: '100%', textAlign: 'center', background: '#EAF3DE', color: '#3B6D11', border: '0.5px solid #3B6D11' }}
                  onClick={async () => {
                    let atualizadas = 0
                    for (const sem of semanas) {
                      const sug = DEADLINES_SUGERIDOS.find(s => s.numero === sem.numero)
                      if (!sug) continue
                      const updates = {}
                      if (!sem.agendado_revelar && sug.revelar) updates.agendado_revelar = sug.revelar
                      if (!sem.agendado_processar && sug.processar) updates.agendado_processar = sug.processar
                      if (Object.keys(updates).length > 0) {
                        await supabase.from('semanas').update(updates).eq('id', sem.id)
                        atualizadas++
                      }
                    }
                    showMsg(`✓ ${atualizadas} semana(s) preenchida(s) com horários sugeridos!`, 'ok')
                    carregar()
                  }}>
                  ✨ Preencher horários sugeridos em todas as semanas criadas
                </button>
              )}
              {/* Botão criar todas as semanas */}
              {DEADLINES_SUGERIDOS.some(sug => !semanas.find(s => s.numero === sug.numero)) && (
                <button style={{ ...s.btnCriar, marginBottom: 10, display: 'block', width: '100%', textAlign: 'center', background: '#EAF3F8', color: '#1A5C9A', border: '0.5px solid #378ADD' }}
                  onClick={async () => {
                    if (!window.confirm(`Criar todas as ${DEADLINES_SUGERIDOS.length} semanas da temporada com horários sugeridos?`)) return
                    let criadas = 0
                    for (const sug of DEADLINES_SUGERIDOS) {
                      if (semanas.find(s => s.numero === sug.numero)) continue
                      const { error } = await supabase.from('semanas').insert({
                        liga_id: temporada.id,
                        numero: sug.numero,
                        tipo: sug.tipo,
                        deadline: sug.deadline,
                        agendado_revelar: sug.revelar,
                        agendado_processar: sug.processar,
                        picks_abertos: false,
                        resultados_processados: false,
                        picks_revelados: false,
                        spreads_congelados: false,
                      })
                      if (!error) criadas++
                    }
                    showMsg(`✓ ${criadas} semana(s) criada(s)!`, 'ok')
                    carregar()
                  }}>
                  📅 Criar todas as semanas da temporada de uma vez
                </button>
              )}
              {DEADLINES_SUGERIDOS.map(sug => {
                const sem = semanas.find(s => s.numero === sug.numero)
                const isCurrent = semana?.numero === sug.numero

                function toLocalInput(iso) {
                  if (!iso) return ''
                  const d = new Date(iso)
                  d.setMinutes(d.getMinutes() - d.getTimezoneOffset())
                  return d.toISOString().slice(0, 16)
                }
                function fromLocalInput(val) {
                  return new Date(val + ':00-03:00').toISOString()
                }
                async function updateSem(campo, valor) {
                  await supabase.from('semanas').update({ [campo]: valor }).eq('id', sem.id)
                  setSemanas(prev => prev.map(s => s.id === sem.id ? { ...s, [campo]: valor } : s))
                  if (isCurrent) setSemana(prev => ({ ...prev, [campo]: valor }))
                  if (campo === 'spreads_congelados' && valor === true && sem?.id) {
                    await congelarSpreadsPicks(sem.id)
                  }
                }

                return (
                  <div key={sug.numero} style={{ ...s.calCard, ...(isCurrent ? s.calCardAtual : sem ? {} : s.calCardInativa) }}>
                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: sug.nota ? 4 : 10, flexWrap: 'wrap' }}>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{sug.label}</div>
                      {isCurrent && <span style={s.atualTag}>atual</span>}
                      {sem?.resultados_processados && <span style={s.processadoTag}>✓ processada</span>}
                      {!sem && <span style={s.inativaTag}>não criada</span>}
                    </div>
                    {sug.nota && <div style={{ fontSize: 10, color: '#888', marginBottom: 10, lineHeight: 1.4 }}>ℹ️ {sug.nota}</div>}

                    {sem ? (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>

                        {/* 1. Deadline picks */}
                        <div style={s.calEventRow}>
                          <div style={s.calEventInfo}>
                            <div style={s.calEventLabel}>📅 Deadline picks</div>
                            <div style={s.calEventSub}>Após este horário os picks são bloqueados</div>
                          </div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                            <input key={`dl-${sem.id}-${sem.deadline}`} type="datetime-local" style={s.inputDate}
                              defaultValue={toLocalInput(sem.deadline)}
                              onBlur={e => updateSem('deadline', fromLocalInput(e.target.value))} />
                            <div style={{ ...s.toggleSm, ...(sem.picks_abertos ? s.toggleSmOn : s.toggleSmOff) }}
                              onClick={() => updateSem('picks_abertos', !sem.picks_abertos)}>
                              <div style={{ ...s.toggleSmDot, ...(sem.picks_abertos ? { right: 2 } : { left: 2 }) }}></div>
                            </div>
                          </div>
                        </div>

                        {/* 2. Revelar escolhas + congelar spreads */}
                        <div style={s.calEventRow}>
                          <div style={s.calEventInfo}>
                            <div style={s.calEventLabel}>👁 Revelar escolhas · congelar spreads</div>
                            <div style={s.calEventSub}>Picks ficam visíveis para todos; spreads não atualizam mais</div>
                          </div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                            {!sem.agendado_revelar && (
                              <button style={s.btnPreencher} onClick={() => updateSem('agendado_revelar', sug.revelar)}>
                                + Sugerido
                              </button>
                            )}
                            <input key={`rev-${sem.id}-${sem.agendado_revelar}`} type="datetime-local" style={s.inputDate}
                              defaultValue={toLocalInput(sem.agendado_revelar || sug.revelar)}
                              onBlur={e => updateSem('agendado_revelar', e.target.value ? fromLocalInput(e.target.value) : null)}
                              title="Horário agendado (automação futura)" />
                            <div style={{ ...s.toggleSm, ...(sem.picks_revelados ? s.toggleSmOn : s.toggleSmOff) }}
                              onClick={() => {
                                updateSem('picks_revelados', !sem.picks_revelados)
                                updateSem('spreads_congelados', !sem.picks_revelados)
                              }}>
                              <div style={{ ...s.toggleSmDot, ...(sem.picks_revelados ? { right: 2 } : { left: 2 }) }}></div>
                            </div>
                          </div>
                        </div>

                        {/* 3. Processar resultados */}
                        <div style={s.calEventRow}>
                          <div style={s.calEventInfo}>
                            <div style={s.calEventLabel}>⚡ Processar resultados</div>
                            <div style={s.calEventSub}>Calcula vidas após todos os jogos terminarem</div>
                          </div>
                          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                            {!sem.agendado_processar && (
                              <button style={s.btnPreencher} onClick={() => updateSem('agendado_processar', sug.processar)}>
                                + Sugerido
                              </button>
                            )}
                            <input key={`proc-${sem.id}-${sem.agendado_processar}`} type="datetime-local" style={s.inputDate}
                              defaultValue={toLocalInput(sem.agendado_processar || sug.processar)}
                              onBlur={e => updateSem('agendado_processar', e.target.value ? fromLocalInput(e.target.value) : null)}
                              title="Horário agendado (automação futura)" />
                            {!sem.resultados_processados ? (
                              <button style={s.btnProcessarSm} onClick={async () => {
                                setProcessando(true)
                                const { sucesso, processados, erro, proximaSemanaAberta, proximoNumero } = await processarResultadosDaSemana(sem.id)
                                setProcessando(false)
                                if (sucesso) {
                                  const msgProxima = proximaSemanaAberta
                                    ? ` · ✅ Semana ${proximoNumero} aberta!`
                                    : ` · ⚠️ Crie a semana ${proximoNumero} no Calendário.`
                                  showMsg(`✓ ${processados} processados!${msgProxima}`, 'ok')
                                  carregar()
                                } else showMsg('Erro: ' + erro, 'erro')
                              }} disabled={processando}>
                                {processando ? '...' : 'Processar agora'}
                              </button>
                            ) : (
                              <button style={s.btnDesfazer} onClick={() => {
                                if (window.confirm('Desfazer processamento da semana? As vidas NÃO serão revertidas automaticamente — faça o ajuste manual se necessário.')) {
                                  updateSem('resultados_processados', false)
                                  showMsg('Processamento desfeito. Ajuste as vidas manualmente se precisar.', 'ok')
                                }
                              }}>↩ Desfazer</button>
                            )}
                            <div style={{ ...s.toggleSm, ...(sem.resultados_processados ? s.toggleSmOn : s.toggleSmOff) }}
                              onClick={() => updateSem('resultados_processados', !sem.resultados_processados)}>
                              <div style={{ ...s.toggleSmDot, ...(sem.resultados_processados ? { right: 2 } : { left: 2 }) }}></div>
                            </div>
                          </div>
                        </div>

                      </div>
                    ) : (
                      <button style={s.btnCriar} onClick={() => criarSemanaComDeadline(sug)}>
                        + Criar semana {sug.numero}
                      </button>
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </>
      )}
    </div>
  )
}

const s = {
  banner: { background: '#FCEBEB', border: '0.5px solid #E24B4A', borderRadius: 8, padding: '8px 12px', marginBottom: '.9rem', fontSize: 12, color: '#A32D2D' },
  msgOk: { background: '#EAF3DE', border: '0.5px solid #3B6D11', borderRadius: 8, padding: '8px 12px', marginBottom: '.9rem', fontSize: 13, color: '#3B6D11' },
  msgErro: { background: '#FCEBEB', border: '0.5px solid #A32D2D', borderRadius: 8, padding: '8px 12px', marginBottom: '.9rem', fontSize: 13, color: '#A32D2D' },
  subNav: { display: 'flex', gap: 4, marginBottom: '1rem', background: '#f0f0f0', borderRadius: 8, padding: 3 },
  subBtn: { flex: 1, padding: '8px', border: 'none', background: 'transparent', borderRadius: 5, fontSize: 12, color: '#666', cursor: 'pointer' },
  subBtnAtivo: { background: '#0A2342', color: 'white', fontWeight: 500 },
  badge: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: '#D85A30', color: 'white', borderRadius: 99, fontSize: 9, fontWeight: 700, width: 14, height: 14, marginLeft: 4, verticalAlign: 'middle' },
  card: { background: 'white', border: '0.5px solid #eee', borderRadius: 10, padding: '13px 14px', marginBottom: '1rem' },
  cardTitle: { fontSize: 13, fontWeight: 500, marginBottom: 12, color: '#0A2342' },
  toggleRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '0.5px solid #f0f0f0' },
  toggleLabel: { fontSize: 13 },
  toggleSub: { fontSize: 11, color: '#999', marginTop: 2 },
  toggle: { width: 36, height: 20, borderRadius: 99, position: 'relative', cursor: 'pointer', flexShrink: 0, transition: 'background .15s' },
  toggleOn: { background: '#D85A30' },
  toggleOff: { background: '#ddd' },
  toggleDot: { width: 16, height: 16, background: 'white', borderRadius: '50%', position: 'absolute', top: 2, transition: 'left .15s, right .15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' },
  btn: { width: '100%', padding: '10px', background: '#0A2342', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', marginTop: 8, fontWeight: 500 },
  btnDanger: { background: 'transparent', color: '#A32D2D', border: '0.5px solid #E24B4A' },
  btnSmall: { width: 28, height: 28, border: '0.5px solid #ddd', borderRadius: 6, background: 'white', cursor: 'pointer', fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  partRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: '0.5px solid #f5f5f5', flexWrap: 'wrap' },
  partElim: { opacity: 0.5 },
  partInfo: { flex: 1 },
  voceTag: { fontSize: 10, background: '#FAECE7', color: '#993C1D', borderRadius: 99, padding: '1px 5px', marginLeft: 5 },
  elimTag: { fontSize: 10, background: '#f5f5f5', color: '#999', borderRadius: 99, padding: '1px 5px', marginLeft: 5 },
  btnAprov: { fontSize: 12, padding: '5px 12px', background: '#EAF3DE', color: '#3B6D11', border: '0.5px solid #3B6D11', borderRadius: 6, cursor: 'pointer' },
  btnEdit: { fontSize: 13, background: 'none', border: 'none', cursor: 'pointer', padding: 2 },
  btnRemove: { fontSize: 11, background: 'none', border: '0.5px solid #E24B4A', borderRadius: 4, color: '#A32D2D', cursor: 'pointer', padding: '2px 5px' },
  btnSave: { fontSize: 12, padding: '3px 8px', background: '#EAF3DE', color: '#3B6D11', border: 'none', borderRadius: 4, cursor: 'pointer' },
  btnCancel: { fontSize: 12, padding: '3px 8px', background: '#FCEBEB', color: '#A32D2D', border: 'none', borderRadius: 4, cursor: 'pointer' },
  inputSmall: { width: 60, padding: '4px 6px', border: '0.5px solid #ddd', borderRadius: 4, fontSize: 12 },
  lembRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '8px 0', borderBottom: '0.5px solid #f5f5f5' },
  btnWpp: { fontSize: 12, padding: '6px 12px', background: '#25D366', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', whiteSpace: 'nowrap', fontWeight: 500 },
  btnWppDis: { fontSize: 12, padding: '6px 12px', background: '#f0f0f0', color: '#bbb', border: 'none', borderRadius: 6, cursor: 'not-allowed', whiteSpace: 'nowrap' },
  vazio: { fontSize: 13, color: '#3B6D11', background: '#EAF3DE', padding: '12px', borderRadius: 8, textAlign: 'center' },
  preview: { fontSize: 12, color: '#555', background: '#f5f5f5', borderRadius: 8, padding: '10px 12px', lineHeight: 1.6, fontStyle: 'italic' },
  erro: { background: '#FCEBEB', color: '#A32D2D', padding: '1rem', borderRadius: 8, fontSize: 13, textAlign: 'center' },
  loading: { fontSize: 13, color: '#888', padding: '2rem 0', textAlign: 'center' },
  calRow: { display: 'flex', alignItems: 'center', gap: 8, padding: '7px 0', borderBottom: '0.5px solid #f5f5f5', flexWrap: 'wrap' },
  calRowAtual: { background: '#FAECE7', borderRadius: 6, padding: '7px 8px', marginBottom: 2 },
  atualTag: { fontSize: 10, background: '#D85A30', color: 'white', borderRadius: 99, padding: '1px 6px' },
  inputDate: { fontSize: 11, padding: '3px 6px', border: '0.5px solid #ddd', borderRadius: 4, color: '#333' },
  btnCriar: { fontSize: 11, padding: '6px 12px', background: '#EAF3F8', color: '#1A5C9A', border: '0.5px solid #378ADD', borderRadius: 6, cursor: 'pointer', marginTop: 4 },
  calCard: { background: 'white', border: '0.5px solid #eee', borderRadius: 10, padding: '12px 14px', marginBottom: 8 },
  calCardAtual: { border: '1.5px solid #D85A30', background: '#FFFBF9' },
  calCardInativa: { background: '#fafafa', opacity: 0.7 },
  inativaTag: { fontSize: 10, background: '#f0f0f0', color: '#999', borderRadius: 99, padding: '1px 6px' },
  processadoTag: { fontSize: 10, background: '#EAF3DE', color: '#3B6D11', borderRadius: 99, padding: '1px 6px' },
  calControlRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12 },
  calEventRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '6px 8px', background: '#fafafa', borderRadius: 6, gap: 8 },
  calEventInfo: { flex: 1 },
  calEventLabel: { fontSize: 12, fontWeight: 500 },
  calEventSub: { fontSize: 10, color: '#999', marginTop: 1 },
  btnProcessarSm: { fontSize: 11, padding: '4px 10px', background: '#0A2342', color: 'white', border: 'none', borderRadius: 4, cursor: 'pointer' },
  btnDesfazer: { fontSize: 11, padding: '4px 10px', background: 'transparent', color: '#A32D2D', border: '0.5px solid #E24B4A', borderRadius: 4, cursor: 'pointer' },
  btnExport: { fontSize: 11, padding: '4px 10px', background: '#EAF3DE', color: '#3B6D11', border: '0.5px solid #3B6D11', borderRadius: 6, cursor: 'pointer' },
  calLabel: { color: '#555' },
  toggleSm: { width: 30, height: 17, borderRadius: 99, position: 'relative', cursor: 'pointer', flexShrink: 0 },
  toggleSmOn: { background: '#D85A30' },
  toggleSmOff: { background: '#ddd' },
  toggleSmDot: { width: 13, height: 13, background: 'white', borderRadius: '50%', position: 'absolute', top: 2, transition: 'left .15s, right .15s', boxShadow: '0 1px 2px rgba(0,0,0,0.2)' },
  btnProcessar: { width: '100%', padding: '7px', background: '#0A2342', color: 'white', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', marginTop: 4, fontWeight: 500 },
}

function NovaLigaForm({ usuario, onCriada }) {
  const [form, setForm] = useState({ nome: '', semana_inicio: 1, vidas_padrao: 3, valor_buyin: 100, chave_pix: '' })
  const [loading, setLoading] = useState(false)

  async function handleCriar() {
    if (!form.nome.trim()) return
    setLoading(true)
    const { error } = await supabase.from('ligas').insert({
      nome: form.nome,
      ano: new Date().getFullYear(),
      criado_por: usuario?.id,
      vidas_padrao: form.vidas_padrao,
      semana_inicio: form.semana_inicio,
      ativa: true,
      inscricoes_abertas: true,
      valor_buyin: form.valor_buyin,
      chave_pix: form.chave_pix,
    })
    setLoading(false)
    if (!error) { onCriada(); setForm({ nome: '', semana_inicio: 1, vidas_padrao: 3, valor_buyin: 100, chave_pix: '' }) }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <div style={{ flex: 2, minWidth: 150 }}>
          <div style={{ fontSize: 11, color: '#666', marginBottom: 3 }}>Nome da liga</div>
          <input style={nf.input} placeholder="Ex: Mortos Vivos 2026" value={form.nome} onChange={e => setForm({...form, nome: e.target.value})} />
        </div>
        <div style={{ flex: 1, minWidth: 80 }}>
          <div style={{ fontSize: 11, color: '#666', marginBottom: 3 }}>Semana início</div>
          <input style={nf.input} type="number" min="1" max="18" value={form.semana_inicio} onChange={e => setForm({...form, semana_inicio: parseInt(e.target.value)})} />
        </div>
        <div style={{ flex: 1, minWidth: 80 }}>
          <div style={{ fontSize: 11, color: '#666', marginBottom: 3 }}>Vidas iniciais</div>
          <input style={nf.input} type="number" min="1" max="10" value={form.vidas_padrao} onChange={e => setForm({...form, vidas_padrao: parseInt(e.target.value)})} />
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 120 }}>
          <div style={{ fontSize: 11, color: '#666', marginBottom: 3 }}>Buy-in (R$)</div>
          <input style={nf.input} type="number" value={form.valor_buyin} onChange={e => setForm({...form, valor_buyin: parseFloat(e.target.value)})} />
        </div>
        <div style={{ flex: 2, minWidth: 150 }}>
          <div style={{ fontSize: 11, color: '#666', marginBottom: 3 }}>Chave PIX</div>
          <input style={nf.input} placeholder="CPF, e-mail ou telefone" value={form.chave_pix} onChange={e => setForm({...form, chave_pix: e.target.value})} />
        </div>
      </div>
      <button style={nf.btn} onClick={handleCriar} disabled={loading || !form.nome.trim()}>
        {loading ? 'Criando...' : '+ Criar liga'}
      </button>
    </div>
  )
}

const nf = {
  input: { width: '100%', padding: '7px 10px', borderRadius: 6, border: '0.5px solid #ddd', fontSize: 12, boxSizing: 'border-box' },
  btn: { padding: '9px', background: '#D85A30', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 },
}
